<div class="outer-container">
    <div class="mobile-menu-icon" *ngIf="!displayOnlyLogo">
        <img class="menu-icon cursor-pointer" src="./images/mobile-menu-icon.svg" (click)="mobileMenuClick()">
        <div class="menu-overlay-background" *ngIf="displayMobileMenu">
            <div class="menu-overlay">
                <div class="header d-flex justify-content-between">
                    <img class="close-icon cursor-pointer" src="./images/close-white.svg" (click)="closeMobileMenu()">
                    <img class="logo" src="./images/logo-white.svg">
                </div>
                <div class="menu-container d-flex flex-column">
                    <div class="menu-list d-flex flex-column">
                        <div class="tab cursor-pointer" (click)="tabClick(1)">
                            {{'header.account' | translate}}</div>
                        <div class="divider"></div>
                        <div class="tab cursor-pointer" (click)="tabClick(2)">
                            {{'header.profile' | translate}}</div>
                        <div class="divider"></div>
                        <div class="tab cursor-pointer" (click)="notificationCenterClick()">
                            {{'header.notificationCenter' | translate}}</div>
                        <div class="divider"></div>

                    </div>
                    <div class="signout-container d-flex" (click)="logout()">
                        <img class="signout-logo" src="./images/logout.svg">
                        <div class="signout">{{'header.signout' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="raees-logo-container">
        <img src="./images/logo-white.svg">
    </div>

    <div class="tab-container" *ngIf="!displayOnlyLogo">
        <div class="tab cursor-pointer" [ngClass]="{'active' : selectedTab == 1}" (click)="tabClick(1)">
            {{'header.account' | translate}}</div>
        <div class="tab cursor-pointer" [ngClass]="{'active' : selectedTab == 2}" (click)="tabClick(2)">
            {{'header.profile' | translate}}</div>
    </div>

    <div class="notification-profile-container" *ngIf="!displayOnlyLogo">
        <div class="notification-container" (click)="notificationClick()">
            <img class="notification cursor-pointer" src="./images/notification.svg">
            <!-- <img class="dot" src="./images/dot.svg"> -->
            <div class="dot" *ngIf="unreadNotificationCount > 0">{{unreadNotificationCount}}</div>
            <div class="notification-popup" *ngIf="showNotification">
                <app-notification-popup [notificationsDetails]="notificationsDetails"></app-notification-popup>
            </div>
        </div>
        <div class="profile-container cursor-pointer">
            <img class="profile" (click)="signoutClick()" [src]='profileImg'>
            <img class="arrow" (click)="signoutClick()" src='./images/arrow.svg'>

            <div class="logout-container" *ngIf="showSignout" (click)="logout()">
                <img class="signout-logo" src="./images/logout.svg">
                <div class="signout">{{'header.signout' | translate}}</div>
            </div>
        </div>
    </div>
</div>